import React from "react";
import styles from "./ContactUs.module.scss";
import ContactUsBanner from "../../assets/images/ContactUsBanner.png";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import classNames from "classnames";
import { Icon } from "./../../assets/Icons.tsx";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";


const cardData = [
  {
    heading: "Aptech Limited (Mumbai Head office)",
    content: `Aptech Limited, Aptech House,<br /> A-65, MIDC, Marol, Andheri (E)<br /> Mumbai – 400093, Maharashtra, India`,
    phone: "Phone: 022-68282300",
  },
  {
    heading: "MEL Training & Assessments Ltd",
    content: `9th floor, Unit 901, Suvidha Square,<br /> Ceasar Road and S V Road, Mogra,<br /> Andheri West, Mumbai Suburban,<br /> Mumbai, 400053, Maharashtra, India`,
    phone: null, // No phone number
  },
  {
    heading: "Corporate office (Bengaluru)",
    content: `Aptech Limited <br /> 6, 6th floor, C wing, Mittal Tower, M.G road,<br /> Bengaluru - 560001`,
    phone: "Phone: 080-40828001/41233165/67",
  },
];

const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "Contact Us", link: "" },
];

const ContactUs: React.FC = () => {
  const content = [
    `Aptech is a pioneer in the vocational training business in India and overseas. It has successfully trained students, professionals, universities and corporates through its two main streams of business through its two main streams of businesses - Domestic and International Retail and Institutional Business (EBG).`,
    `Find Aptech’s contact information for Aptech offices, retail & corporate businesses and corporate communications. `,
  ];
  const navigate = useNavigate();

  return (
    <div className={styles.ContactUs}>
      <BreadCrumb menu={breadcrumb} />
      <div className="container">
        <div className="section">
        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
          <div className="row mt-5">
            <div className="col-12">
              <ImageTextSection
                imageSrc={ContactUsBanner}
                imageAlt="ContactUsBannerImage"
                content={content}
                heading="Aptech Contact Details"
                reverse={true}
                imageHeight={`25rem`}
                imageHeightTablet={`25rem`}
                colImageValue={5}
                colTextValue={7}
                imageAlign="end"
              />
            </div>
          </div>
          </motion.div>
        </div>
      </div>
      <div className="container">
      <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
        <div className="row d-flex justify-content-center align-items-stretch">
          {cardData.map((card, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12 d-flex" key={index}>
              <AddressCard card={card} />
            </div>
          ))}
        </div>
        </motion.div>
        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
        <div className="row mt-4 d-flex justify-content-center">
          <div className={classNames("col-lg-8 col-md-12 col-sm-12")}>
            <div className={styles.regionalOffice}>
              <div className={styles.card}>
                <div className={styles.headingContainer}>
                  <div className={classNames(styles.heading, "para caps")}>
                    Regional Offices (NOIDA)
                  </div>
                  <div className={classNames(styles.compass, "para")}>
                    {/* <Icon name="compass" color="var(--primary)" /> */}
                    <strong> NORTH</strong>
                  </div>
                </div>
                <div className="row">
                  <div className={`col-md-6`}>
                    <div className={styles.content}>
                      <div
                        className="para"
                        dangerouslySetInnerHTML={{
                          __html: `<p className="para">
                         Institutional Business (EBG)<br/>
                        Aptech Limited <br/>
                        B-26 & 27, 1st floor, Sector-1, Noida <br />
                        Uttar Pradesh – 201301, India
                      </p>`,
                        }}
                      />
                      <div className={styles.contact}>
                        <Icon name="phone" color="var(--primary)" />
                        <div className={classNames(styles.info, "para")}>
                          <strong>Phone: 120-4505600</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={classNames(`col-md-6`)}>
                    <div
                      className={classNames(styles.colBorder, styles.content)}
                    >
                      <div
                        className="para"
                        dangerouslySetInnerHTML={{
                          __html: `<p className="para">
                        Retail Business <br/>
                        Aptech Limited <br/>
                        B- 40, Ground Floor, Sector-02, Noida  <br />
                        Uttar Pradesh – 201301, India 
                      </p>`,
                        }}
                      />
                      <div className={styles.contact}>
                        <Icon name="phone" color="var(--primary)" />
                        <div className={classNames(styles.info, "para")}>
                          <strong>Phone: 120-4505600</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={classNames("col-lg-4 col-md-12")}>
            <div className={styles.CustomerCare}>
              <div className={styles.card}>
                <p className={classNames(styles.heading, "para caps")}>
                  Aptech Customer Care
                </p>
                <div className={styles.content}>
                  <div
                    className="para"
                    dangerouslySetInnerHTML={{
                      __html: `<p>
                  Contact customer care representatives at Aptech in case of
                  complaints or grievances. We'll review your complaint/grievance
                  and work with you to resolve the issue at the earliest.
                </p>`,
                    }}
                  />
                  <div
                    className={`d-flex align-items-center justify-content-center ${styles.complaintButtonDiv}`}
                  >
                    <button
                      className="secondary-btn"
                      onClick={() =>
                        window.open(
                          "https://docs.google.com/forms/d/e/1FAIpQLSeIRCXFO5IyrWEoZJmBotgoqQf8XEOVT1DnoSWx45iyaaDsTw/viewform",
                          "_blank"
                        )
                      }
                    >
                      Submit your complaint
                    </button>
                    <div
                      className={classNames(styles.link, "para")}
                      onClick={() => navigate("/disclaimer#profinitySection")}
                    >
                      Profanity Policy
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </motion.div>

        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >

        <div className="row mt-4 d-flex align-items-stretch">
          <div
            className={classNames(
              styles.Secretary,
              "col-lg-6 col-md-12 col-sm-12 d-flex"
            )}
          >
            <div className={`${styles.card} flex-fill`}>
              <p
                className={classNames(
                  styles.headingSecretary,
                  "para caps mb-0"
                )}
              >
                <strong>COrporate communications/media relations</strong>
              </p>
              <div className={styles.content}>
                <div
                  className="para"
                  dangerouslySetInnerHTML={{
                    __html: `<p>Srinidhi Iyer<br>Aptech Limited<br>Aptech House, A-65 <br>MIDC Marol, Andheri (East), Mumbai – 400093</p>`,
                  }}
                />
                <div className={styles.contact}>
                  <Icon name="phone" color="var(--primary)" />
                  <div className={classNames(styles.info, "para")}>
                    <strong>Direct: 022 68282425</strong>
                  </div>
                </div>
                <div className={styles.contact}>
                  <Icon name="email" color="var(--primary)" />
                  <div className={classNames(styles.info, "para")}>
                    Email:{" "}
                    <a
                      href="mailto:srinidhi.iyer@aptech.co.in"
                      className={styles.link}
                    >
                      srinidhi.iyer@aptech.co.in
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={classNames(
              styles.Investor,
              "col-lg-6 col-md-12 col-sm-12 d-flex flex-column"
            )}
          >
            <div className={`${styles.card} flex-fill`}>
              <p className={classNames(styles.heading, "para caps mb-0")}>
                <strong>Investor contacts</strong>
              </p>
              <div className={styles.content}>
                <p className="para caps">
                  <strong>Registrar and Share Transfer Agent</strong>
                </p>
                <div
                  className="para"
                  dangerouslySetInnerHTML={{
                    __html: `<p>KFIN Technologies Private Limited<br/>Unit: Aptech Limited<br/>Selenium Tower B,Plot No. 31 & 32,  Financial District, <br />
          Nanakramguda, Gachibowli, Telangana - 500032, Hyderabad</p>`,
                  }}
                />
                <div className={styles.contact}>
                  <Icon name="phone" color="var(--primary)" />
                  <div className={classNames(styles.info, "para")}>
                    Toll Free No:{" "}
                    <a href="call:1800 309 4001" className={styles.link}>
                      1800 309 4001
                    </a>
                  </div>
                </div>
                <div className={styles.contact}>
                  <Icon name="email" color="var(--primary)" />
                  <div className={classNames(styles.info, "para")}>
                    Email:{" "}
                    <a
                      href="mailto:einward.ris@kfintech.com"
                      className={styles.link}
                    >
                      einward.ris@kfintech.com
                    </a>
                  </div>
                </div>
                <div className={styles.contact}>
                  <Icon name="glob" color="var(--primary)" />
                  <div className={classNames(styles.info, "para")}>
                    Website:{" "}
                    <a
                      href="https://www.kfintech.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.link}
                    >
                      www.kfintech.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </motion.div>

        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
        <div className="row">
          <div className="col-6"></div>
          <div className="col-lg-6 col-md-12 col-sm-12">
            <div className={classNames(styles.Suggestions)}>
              <div className={styles.content}>
                <p className="para caps mb-0">
                  <strong>For investor queries & suggestions, email</strong>
                </p>
                <div className={styles.contact}>
                  <Icon name="email" color="var(--primary)" />
                  <div className={classNames(styles.info, "para")}>
                    <a
                      href="mailto:investors_relations@aptech.co.in "
                      className={styles.link}
                      style={{fontWeight:'400'}}
                    >
                      investors_relations@aptech.co.in 
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </motion.div>

        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
        <div className="row mt-5">
          <div className="col-lg-6 col-md-12 col-sm-12">
            <BusinessContact />
          </div>
          <div
            className={classNames(
              styles.Secretary,
              "col-lg-6 col-md-12 col-sm-12"
            )}
          >
            <div className={styles.card}>
              <p
                className={classNames(
                  styles.headingSecretary,
                  "para caps mb-0"
                )}
              >
                <strong>Group Company Secretary</strong>
              </p>
              <div className={styles.content}>
                <div
                  className="para"
                  dangerouslySetInnerHTML={{
                    __html: `<p>Ms. Shruti Laud<br>Aptech Limited<br>Aptech House, A-65 <br>MIDC Marol, Andheri (East), Mumbai – 400093</p>`,
                  }}
                />
                <div className={styles.contact}>
                  <Icon name="email" color="var(--primary)" />
                  <div className={classNames(styles.info, "para")}>
                    Email:{" "}
                    <a href="mailto:cs@aptech.co.in" className={styles.link}>
                      cs@aptech.co.in
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </motion.div>
      </div>
    </div>
  );
};

const AddressCard = ({ card }) => {
  return (
    <div className={`${styles.card} flex-grow-1`}>
      <p className={classNames(styles.heading, "para caps mb-0")}>
        {card.heading}
      </p>
      <div className={styles.content}>
        <div
          className="para"
          dangerouslySetInnerHTML={{ __html: card.content }}
        />
        {card.phone && (
          <div className={styles.contact}>
            <Icon name="phone" color="var(--primary)" />
            <div className={classNames(styles.info, "para")}>
              <strong>{card.phone}</strong>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const BusinessContact = () => {
  const corporate = [
    {
      title: "Aptech Training Solutions",
      link: "http://www.aptechtrainingsolutions.com/contactus.shtml ",
    },
    { title: "Aptech Assessment & Testing Solutions" },
    { title: "Education Institutes and Corporates (EIC) Unit" },
  ];
  const retail = [
    {
      title: "Arena Animation",
      link: " https://www.arena-multimedia.com/in/en/contact-us",
    },
    { title: "MAAC", link: "https://www.maacindia.com/contact-us" },
    {
      title: "Aptech Learning",
      link: "https://www.aptechlearning.com/it/contact-us.aspx ",
    },
    {
      title: "Avalon Academy",
      link: "https://www.aptechaviationacademy.com/contact-us ",
    },
    {
      title: "Lakmé Academy powered by Aptech",
      link: "https://www.lakme-academy.com/contact-us ",
    },
    {
      title: "Aptech International Preschool",
      link: "https://www.aptechinternationalpreschool.com/contact-us/",
    },
    {
      title: "Aptech Global Training",
      link: "https://www.aptechglobaltraining.com/contact-us",
    },
    { title: "ProAlley", link: "https://www.proalley.com/contactus " },
    {
      title: "The Virtual Production Academy",
      link: "https://thevirtualproductionacademy.com/contact-us/ ",
    },
  ];
  return (
    <div className={styles.BusinessContact}>
      <div className={classNames(styles.heading, "para caps")}>
        <strong>Business contacts</strong>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className={classNames(styles.heading, "para caps pt-2")}>
            <strong>Domestic Retail</strong>
          </div>
          <div className={styles.content}>
            {retail.map((item, i) => (
              <a
                className={classNames(styles.link, "para")}
                href={item.link}
                key={i}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.title}
              </a>
            ))}
          </div>
        </div>
        <div className="col-md-6">
          <div
            className={classNames(
              styles.heading,
              styles.corporateHeading,
              "para caps pt-2"
            )}
          >
            <strong className={`${styles.corporateHeading}`}>
              Institutional Business (EBG)
            </strong>
          </div>
          <div className={styles.content}>
            {corporate.map((item, i) => (
              <a
                className={classNames(styles.link, "para")}
                href={item.link}
                key={i}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.title}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
